export default __webpack_public_path__ + "static/media/creepy.f359aaba.mp3";